'use client'

import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from '@mui/material'
import cx from 'clsx'
import { ElementType, HTMLAttributeAnchorTarget } from 'react'

import styles from './button.module.scss'

export type ButtonProps<RootComponent extends ElementType = 'button'> =
  MuiButtonProps<RootComponent> & {
    color?: 'primary' | 'secondary' | 'inherit'
    variant?: 'contained' | 'outlined' | 'text'
    disableUnderline?: boolean
    target?: HTMLAttributeAnchorTarget
  }

export const Button = <RootComponent extends ElementType = 'button'>(
  props: ButtonProps<RootComponent>,
) => {
  const {
    color = 'primary',
    variant = 'contained',
    children = 'Button',
    className,
    disableUnderline = false,
    ...rest
  } = props

  const hasUnderline = variant === 'text' && !disableUnderline

  return (
    <MuiButton
      className={cx(styles.button, className, {
        [styles.underline]: hasUnderline,
      })}
      color={color}
      variant={variant}
      {...rest}
    >
      {hasUnderline ? (
        <span className={styles.buttonContent}>{children}</span>
      ) : (
        children
      )}
    </MuiButton>
  )
}
